import { I as f, b as m, y as d, g as E, $ as v, E as re, _ as oe, N as x, J as We, K as Be } from "./__searchspring__deps__main-kCZHrJ1L.js";
var h, u, U, W, N = 0, ue = [], k = [], a = f, B = a.__b, q = a.__r, z = a.diffed, j = a.__c, Y = a.unmount, Z = a.__;
function y(e, t) {
  a.__h && a.__h(u, e, N || t), N = 0;
  var n = u.__H || (u.__H = { __: [], __h: [] });
  return e >= n.__.length && n.__.push({ __V: k }), n.__[e];
}
function O(e) {
  return N = 1, T(pe, e);
}
function T(e, t, n) {
  var _ = y(h++, 2);
  if (_.t = e, !_.__c && (_.__ = [n ? n(t) : pe(void 0, t), function(c) {
    var l = _.__N ? _.__N[0] : _.__[0], s = _.t(l, c);
    l !== s && (_.__N = [s, _.__[1]], _.__c.setState({}));
  }], _.__c = u, !u.u)) {
    var r = function(c, l, s) {
      if (!_.__c.__H)
        return !0;
      var $ = _.__c.__H.__.filter(function(p) {
        return !!p.__c;
      });
      if ($.every(function(p) {
        return !p.__N;
      }))
        return !o || o.call(this, c, l, s);
      var M = !1;
      return $.forEach(function(p) {
        if (p.__N) {
          var Me = p.__[0];
          p.__ = p.__N, p.__N = void 0, Me !== p.__[0] && (M = !0);
        }
      }), !(!M && _.__c.props === c) && (!o || o.call(this, c, l, s));
    };
    u.u = !0;
    var o = u.shouldComponentUpdate, i = u.componentWillUpdate;
    u.componentWillUpdate = function(c, l, s) {
      if (this.__e) {
        var $ = o;
        o = void 0, r(c, l, s), o = $;
      }
      i && i.call(this, c, l, s);
    }, u.shouldComponentUpdate = r;
  }
  return _.__N || _.__;
}
function A(e, t) {
  var n = y(h++, 3);
  !a.__s && F(n.__H, t) && (n.__ = e, n.i = t, u.__H.__h.push(n));
}
function g(e, t) {
  var n = y(h++, 4);
  !a.__s && F(n.__H, t) && (n.__ = e, n.i = t, u.__h.push(n));
}
function ie(e) {
  return N = 5, P(function() {
    return { current: e };
  }, []);
}
function ae(e, t, n) {
  N = 6, g(function() {
    return typeof e == "function" ? (e(t()), function() {
      return e(null);
    }) : e ? (e.current = t(), function() {
      return e.current = null;
    }) : void 0;
  }, n == null ? n : n.concat(e));
}
function P(e, t) {
  var n = y(h++, 7);
  return F(n.__H, t) ? (n.__V = e(), n.i = t, n.__h = e, n.__V) : n.__;
}
function ce(e, t) {
  return N = 8, P(function() {
    return e;
  }, t);
}
function le(e) {
  var t = u.context[e.__c], n = y(h++, 9);
  return n.c = e, t ? (n.__ == null && (n.__ = !0, t.sub(u)), t.props.value) : e.__;
}
function fe(e, t) {
  a.useDebugValue && a.useDebugValue(t ? t(e) : e);
}
function qe(e) {
  var t = y(h++, 10), n = O();
  return t.__ = e, u.componentDidCatch || (u.componentDidCatch = function(_, r) {
    t.__ && t.__(_, r), n[1](_);
  }), [n[0], function() {
    n[1](void 0);
  }];
}
function se() {
  var e = y(h++, 11);
  if (!e.__) {
    for (var t = u.__v; t !== null && !t.__m && t.__ !== null; )
      t = t.__;
    var n = t.__m || (t.__m = [0, 0]);
    e.__ = "P" + n[0] + "-" + n[1]++;
  }
  return e.__;
}
function ze() {
  for (var e; e = ue.shift(); )
    if (e.__P && e.__H)
      try {
        e.__H.__h.forEach(R), e.__H.__h.forEach(D), e.__H.__h = [];
      } catch (t) {
        e.__H.__h = [], a.__e(t, e.__v);
      }
}
a.__b = function(e) {
  u = null, B && B(e);
}, a.__ = function(e, t) {
  e && t.__k && t.__k.__m && (e.__m = t.__k.__m), Z && Z(e, t);
}, a.__r = function(e) {
  q && q(e), h = 0;
  var t = (u = e.__c).__H;
  t && (U === u ? (t.__h = [], u.__h = [], t.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.__V = k, n.__N = n.i = void 0;
  })) : (t.__h.forEach(R), t.__h.forEach(D), t.__h = [], h = 0)), U = u;
}, a.diffed = function(e) {
  z && z(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (ue.push(t) !== 1 && W === a.requestAnimationFrame || ((W = a.requestAnimationFrame) || je)(ze)), t.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.__V !== k && (n.__ = n.__V), n.i = void 0, n.__V = k;
  })), U = u = null;
}, a.__c = function(e, t) {
  t.some(function(n) {
    try {
      n.__h.forEach(R), n.__h = n.__h.filter(function(_) {
        return !_.__ || D(_);
      });
    } catch (_) {
      t.some(function(r) {
        r.__h && (r.__h = []);
      }), t = [], a.__e(_, n.__v);
    }
  }), j && j(e, t);
}, a.unmount = function(e) {
  Y && Y(e);
  var t, n = e.__c;
  n && n.__H && (n.__H.__.forEach(function(_) {
    try {
      R(_);
    } catch (r) {
      t = r;
    }
  }), n.__H = void 0, t && a.__e(t, n.__v));
};
var J = typeof requestAnimationFrame == "function";
function je(e) {
  var t, n = function() {
    clearTimeout(_), J && cancelAnimationFrame(t), setTimeout(e);
  }, _ = setTimeout(n, 100);
  J && (t = requestAnimationFrame(n));
}
function R(e) {
  var t = u, n = e.__c;
  typeof n == "function" && (e.__c = void 0, n()), u = t;
}
function D(e) {
  var t = u;
  e.__c = e.__(), u = t;
}
function F(e, t) {
  return !e || e.length !== t.length || t.some(function(n, _) {
    return n !== e[_];
  });
}
function pe(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function de(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}
function w(e, t) {
  for (var n in e)
    if (n !== "__source" && !(n in t))
      return !0;
  for (var _ in t)
    if (_ !== "__source" && e[_] !== t[_])
      return !0;
  return !1;
}
function H(e, t) {
  this.props = e, this.context = t;
}
function he(e, t) {
  function n(r) {
    var o = this.props.ref, i = o == r.ref;
    return !i && o && (o.call ? o(null) : o.current = null), t ? !t(this.props, r) || !i : w(this.props, r);
  }
  function _(r) {
    return this.shouldComponentUpdate = n, d(e, r);
  }
  return _.displayName = "Memo(" + (e.displayName || e.name) + ")", _.prototype.isReactComponent = !0, _.__f = !0, _;
}
(H.prototype = new m()).isPureReactComponent = !0, H.prototype.shouldComponentUpdate = function(e, t) {
  return w(this.props, e) || w(this.state, t);
};
var K = f.__b;
f.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), K && K(e);
};
var Ye = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function ve(e) {
  function t(n) {
    var _ = de({}, n);
    return delete _.ref, e(_, n.ref || null);
  }
  return t.$$typeof = Ye, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
}
var G = function(e, t) {
  return e == null ? null : v(v(e).map(t));
}, me = { map: G, forEach: G, count: function(e) {
  return e ? v(e).length : 0;
}, only: function(e) {
  var t = v(e);
  if (t.length !== 1)
    throw "Children.only";
  return t[0];
}, toArray: v }, Ze = f.__e;
f.__e = function(e, t, n, _) {
  if (e.then) {
    for (var r, o = t; o = o.__; )
      if ((r = o.__c) && r.__c)
        return t.__e == null && (t.__e = n.__e, t.__k = n.__k), r.__c(e, t);
  }
  Ze(e, t, n, _);
};
var Q = f.unmount;
function ye(e, t, n) {
  return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(_) {
    typeof _.__c == "function" && _.__c();
  }), e.__c.__H = null), (e = de({}, e)).__c != null && (e.__c.__P === n && (e.__c.__P = t), e.__c = null), e.__k = e.__k && e.__k.map(function(_) {
    return ye(_, t, n);
  })), e;
}
function be(e, t, n) {
  return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function(_) {
    return be(_, t, n);
  }), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function C() {
  this.__u = 0, this.t = null, this.__b = null;
}
function Ee(e) {
  var t = e.__.__c;
  return t && t.__a && t.__a(e);
}
function Ne(e) {
  var t, n, _;
  function r(o) {
    if (t || (t = e()).then(function(i) {
      n = i.default || i;
    }, function(i) {
      _ = i;
    }), _)
      throw _;
    if (!n)
      throw t;
    return d(n, o);
  }
  return r.displayName = "Lazy", r.__f = !0, r;
}
function b() {
  this.u = null, this.o = null;
}
f.unmount = function(e) {
  var t = e.__c;
  t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Q && Q(e);
}, (C.prototype = new m()).__c = function(e, t) {
  var n = t.__c, _ = this;
  _.t == null && (_.t = []), _.t.push(n);
  var r = Ee(_.__v), o = !1, i = function() {
    o || (o = !0, n.__R = null, r ? r(c) : c());
  };
  n.__R = i;
  var c = function() {
    if (!--_.__u) {
      if (_.state.__a) {
        var l = _.state.__a;
        _.__v.__k[0] = be(l, l.__c.__P, l.__c.__O);
      }
      var s;
      for (_.setState({ __a: _.__b = null }); s = _.t.pop(); )
        s.forceUpdate();
    }
  };
  _.__u++ || 32 & t.__u || _.setState({ __a: _.__b = _.__v.__k[0] }), e.then(i, i);
}, C.prototype.componentWillUnmount = function() {
  this.t = [];
}, C.prototype.render = function(e, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"), _ = this.__v.__k[0].__c;
      this.__v.__k[0] = ye(this.__b, n, _.__O = _.__P);
    }
    this.__b = null;
  }
  var r = t.__a && d(E, null, e.fallback);
  return r && (r.__u &= -33), [d(E, null, t.__a ? null : e.children), r];
};
var X = function(e, t, n) {
  if (++n[1] === n[0] && e.o.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.o.size))
    for (n = e.u; n; ) {
      for (; n.length > 3; )
        n.pop()();
      if (n[1] < n[0])
        break;
      e.u = n = n[2];
    }
};
function Je(e) {
  return this.getChildContext = function() {
    return e.context;
  }, e.children;
}
function Ke(e) {
  var t = this, n = e.i;
  t.componentWillUnmount = function() {
    x(null, t.l), t.l = null, t.i = null;
  }, t.i && t.i !== n && t.componentWillUnmount(), t.l || (t.i = n, t.l = { nodeType: 1, parentNode: n, childNodes: [], appendChild: function(_) {
    this.childNodes.push(_), t.i.appendChild(_);
  }, insertBefore: function(_, r) {
    this.childNodes.push(_), t.i.appendChild(_);
  }, removeChild: function(_) {
    this.childNodes.splice(this.childNodes.indexOf(_) >>> 1, 1), t.i.removeChild(_);
  } }), x(d(Je, { context: t.context }, e.__v), t.l);
}
function Ce(e, t) {
  var n = d(Ke, { __v: e, i: t });
  return n.containerInfo = t, n;
}
(b.prototype = new m()).__a = function(e) {
  var t = this, n = Ee(t.__v), _ = t.o.get(e);
  return _[0]++, function(r) {
    var o = function() {
      t.props.revealOrder ? (_.push(r), X(t, e, _)) : r();
    };
    n ? n(o) : o();
  };
}, b.prototype.render = function(e) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var t = v(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
  for (var n = t.length; n--; )
    this.o.set(t[n], this.u = [1, 0, this.u]);
  return e.children;
}, b.prototype.componentDidUpdate = b.prototype.componentDidMount = function() {
  var e = this;
  this.o.forEach(function(t, n) {
    X(e, n, t);
  });
};
var ge = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Ge = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Qe = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Xe = /[A-Z0-9]/g, et = typeof document < "u", tt = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
};
function Se(e, t, n) {
  return t.__k == null && (t.textContent = ""), x(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function $e(e, t, n) {
  return We(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
m.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(e) {
  Object.defineProperty(m.prototype, e, { configurable: !0, get: function() {
    return this["UNSAFE_" + e];
  }, set: function(t) {
    Object.defineProperty(this, e, { configurable: !0, writable: !0, value: t });
  } });
});
var ee = f.event;
function nt() {
}
function _t() {
  return this.cancelBubble;
}
function rt() {
  return this.defaultPrevented;
}
f.event = function(e) {
  return ee && (e = ee(e)), e.persist = nt, e.isPropagationStopped = _t, e.isDefaultPrevented = rt, e.nativeEvent = e;
};
var I, ot = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, te = f.vnode;
f.vnode = function(e) {
  typeof e.type == "string" && function(t) {
    var n = t.props, _ = t.type, r = {};
    for (var o in n) {
      var i = n[o];
      if (!(o === "value" && "defaultValue" in n && i == null || et && o === "children" && _ === "noscript" || o === "class" || o === "className")) {
        var c = o.toLowerCase();
        o === "defaultValue" && "value" in n && n.value == null ? o = "value" : o === "download" && i === !0 ? i = "" : c === "translate" && i === "no" ? i = !1 : c === "ondoubleclick" ? o = "ondblclick" : c !== "onchange" || _ !== "input" && _ !== "textarea" || tt(n.type) ? c === "onfocus" ? o = "onfocusin" : c === "onblur" ? o = "onfocusout" : Qe.test(o) ? o = c : _.indexOf("-") === -1 && Ge.test(o) ? o = o.replace(Xe, "-$&").toLowerCase() : i === null && (i = void 0) : c = o = "oninput", c === "oninput" && r[o = c] && (o = "oninputCapture"), r[o] = i;
      }
    }
    _ == "select" && r.multiple && Array.isArray(r.value) && (r.value = v(n.children).forEach(function(l) {
      l.props.selected = r.value.indexOf(l.props.value) != -1;
    })), _ == "select" && r.defaultValue != null && (r.value = v(n.children).forEach(function(l) {
      l.props.selected = r.multiple ? r.defaultValue.indexOf(l.props.value) != -1 : r.defaultValue == l.props.value;
    })), n.class && !n.className ? (r.class = n.class, Object.defineProperty(r, "className", ot)) : (n.className && !n.class || n.class && n.className) && (r.class = r.className = n.className), t.props = r;
  }(e), e.$$typeof = ge, te && te(e);
};
var ne = f.__r;
f.__r = function(e) {
  ne && ne(e), I = e.__c;
};
var _e = f.diffed;
f.diffed = function(e) {
  _e && _e(e);
  var t = e.props, n = e.__e;
  n != null && e.type === "textarea" && "value" in t && t.value !== n.value && (n.value = t.value == null ? "" : t.value), I = null;
};
var ke = { ReactCurrentDispatcher: { current: { readContext: function(e) {
  return I.__n[e.__c].props.value;
} } } }, ut = "17.0.2";
function Re(e) {
  return d.bind(null, e);
}
function S(e) {
  return !!e && e.$$typeof === ge;
}
function xe(e) {
  return S(e) && e.type === E;
}
function He(e) {
  return !!e && !!e.displayName && (typeof e.displayName == "string" || e.displayName instanceof String) && e.displayName.startsWith("Memo(");
}
function Oe(e) {
  return S(e) ? Be.apply(null, arguments) : e;
}
function Pe(e) {
  return !!e.__k && (x(null, e), !0);
}
function Ue(e) {
  return e && (e.base || e.nodeType === 1 && e) || null;
}
var Ve = function(e, t) {
  return e(t);
}, De = function(e, t) {
  return e(t);
}, we = E;
function L(e) {
  e();
}
function Te(e) {
  return e;
}
function Ae() {
  return [!1, L];
}
var Fe = g, Ie = S;
function Le(e, t) {
  var n = t(), _ = O({ h: { __: n, v: t } }), r = _[0].h, o = _[1];
  return g(function() {
    r.__ = n, r.v = t, V(r) && o({ h: r });
  }, [e, n, t]), A(function() {
    return V(r) && o({ h: r }), e(function() {
      V(r) && o({ h: r });
    });
  }, [e]), n;
}
function V(e) {
  var t, n, _ = e.v, r = e.__;
  try {
    var o = _();
    return !((t = r) === (n = o) && (t !== 0 || 1 / t == 1 / n) || t != t && n != n);
  } catch {
    return !0;
  }
}
var it = { useState: O, useId: se, useReducer: T, useEffect: A, useLayoutEffect: g, useInsertionEffect: Fe, useTransition: Ae, useDeferredValue: Te, useSyncExternalStore: Le, startTransition: L, useRef: ie, useImperativeHandle: ae, useMemo: P, useCallback: ce, useContext: le, useDebugValue: fe, version: "17.0.2", Children: me, render: Se, hydrate: $e, unmountComponentAtNode: Pe, createPortal: Ce, createElement: d, createContext: re, createFactory: Re, cloneElement: Oe, createRef: oe, Fragment: E, isValidElement: S, isElement: Ie, isFragment: xe, isMemo: He, findDOMNode: Ue, Component: m, PureComponent: H, memo: he, forwardRef: ve, flushSync: De, unstable_batchedUpdates: Ve, StrictMode: we, Suspense: C, SuspenseList: b, lazy: Ne, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ke };
const ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Children: me,
  Component: m,
  Fragment: E,
  PureComponent: H,
  StrictMode: we,
  Suspense: C,
  SuspenseList: b,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ke,
  cloneElement: Oe,
  createContext: re,
  createElement: d,
  createFactory: Re,
  createPortal: Ce,
  createRef: oe,
  default: it,
  findDOMNode: Ue,
  flushSync: De,
  forwardRef: ve,
  hydrate: $e,
  isElement: Ie,
  isFragment: xe,
  isMemo: He,
  isValidElement: S,
  lazy: Ne,
  memo: he,
  render: Se,
  startTransition: L,
  unmountComponentAtNode: Pe,
  unstable_batchedUpdates: Ve,
  useCallback: ce,
  useContext: le,
  useDebugValue: fe,
  useDeferredValue: Te,
  useEffect: A,
  useErrorBoundary: qe,
  useId: se,
  useImperativeHandle: ae,
  useInsertionEffect: Fe,
  useLayoutEffect: g,
  useMemo: P,
  useReducer: T,
  useRef: ie,
  useState: O,
  useSyncExternalStore: Le,
  useTransition: Ae,
  version: ut
}, Symbol.toStringTag, { value: "Module" }));
export {
  ct as $,
  me as A,
  H as E,
  ie as F,
  ve as N,
  le as P,
  Fe as S,
  A as _,
  it as a,
  g as b,
  Ve as c,
  S as f,
  se as g,
  Oe as h,
  Ce as j,
  De as m,
  O as p,
  P as q,
  he as w,
  ce as x,
  T as y
};
